<app-stages [stages]="stages" currentStage="Zgody"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate [formGroup]='form' (ngSubmit)="submitAndGoNext()">
    <input type="submit" hidden>
    <fieldset>
      <legend>
        Zapoznaj się z regulaminem oraz klauzulą.
      </legend>
      <br>
      <app-accordion-group>
        <app-accordion-item [expanded]='true' name='Regulamin'>
          <ng-container *ngIf='subpages() | subpageContentByUrl: "regulamin" as subpage'>
            <div class='editor-content' [innerHTML]='subpage?.content'></div>
          </ng-container>
        </app-accordion-item>
      </app-accordion-group>
      <br>
      <div class='form-group' *ngIf='"regulations" as controlName'>
        <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
          <input
            [formControlName]='controlName'
            type='checkbox'
            [id]='controlName'
            [name]='controlName'>
          <label [for]='controlName'>
            * Zapoznałem/am się z regulaminem e-usługi
          </label>
        </div>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
      <app-accordion-group>
        <app-accordion-item [expanded]='true' name='Klauzula RODO'>
          <ng-container *ngIf='rodoContent() as content'>
            <div class='editor-content' [innerHTML]='content'></div>
          </ng-container>
        </app-accordion-item>
      </app-accordion-group>
      <br>
      <div class='form-group' *ngIf='"clause" as controlName'>
        <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
          <input
            [formControlName]='controlName'
            type='checkbox'
            [id]='controlName'
            [name]='controlName'>
          <label [for]='controlName'>
            * Zapoznałem/am się z klauzulą informacyjną RODO
          </label>
        </div>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </fieldset>
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
